/**
 * 主站前台 - 联系我们
 * 路由: /contact
 * 数据源: GET /api/cms/pages/contact
 */

import { useState, useEffect } from 'react';
import api from '../services/api';

export default function Contact() {
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadPage();
  }, []);

  const loadPage = async () => {
    try {
      const response = await api.get('/cms/pages/contact');
      setPage(response.data.page);
    } catch (error) {
      console.error('加载页面失败:', error);
    } finally {
      setLoading(false);
    }
  };

  const extractHtml = (content) => {
    if (!content) return '';
    if (typeof content === 'string') return content;
    if (typeof content === 'object' && content.html) return content.html;
    return '';
  };

  const contentHtml = page ? extractHtml(page.content) : '';

  return (
    <div className="pt-24 pb-20 min-h-screen">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* 页头 */}
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">联系我们</h1>
        </div>

        {/* 内容区 */}
        {loading ? (
          <div className="text-center py-20">
            <div className="inline-block w-8 h-8 border-2 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
          </div>
        ) : contentHtml ? (
          <article
            className="prose prose-invert prose-lg max-w-none
              prose-headings:text-white prose-headings:font-bold
              prose-p:text-gray-300 prose-p:leading-relaxed
              prose-a:text-blue-400
              prose-strong:text-white
              prose-blockquote:border-blue-500 prose-blockquote:text-gray-400
              prose-img:rounded-lg"
            dangerouslySetInnerHTML={{ __html: contentHtml }}
          />
        ) : (
          <div className="text-center py-20">
            <div className="text-6xl mb-6 opacity-20">📧</div>
            <h2 className="text-2xl font-bold text-white mb-3">与我们取得联系</h2>
            <p className="text-gray-400 max-w-lg mx-auto">
              如有任何问题或建议，欢迎通过以下方式联系我们。我们将尽快回复您。
            </p>
            <div className="mt-8 space-y-4">
              <div className="text-gray-300">
                <span className="text-gray-500">邮箱：</span>
                <span>support@noconb.com</span>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
